const topics = [
  {
    title: "-----Indigenous People-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "",
    music: "",
    lyrics: [
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Colonial Women-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Women During the Revolutionary War-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Women During the Civil War-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Women During World War II-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Harriet Tubman-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Graceanna Lewis-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Ellen Craft-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Nat Turner's Rebellion-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Gabriel Prosser's Rebellion-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Slave Revolts-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Underground Railroad-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Resistance and Reform-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Reform and Compromise-----",
    subtitle1: "Topic: 1",
    description: "5.B.1 Understand ways in which values and beliefs have influenced the development of the United States.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Constitution-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.1 Analyze the structure and function of the United States government in terms of cooperation and compromise.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftheconstitutionvideo2025.mp4?alt=media&token=60be23b0-6432-4d5b-8503-6a99b6380b31",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheconstitution2025song.mp3?alt=media&token=10bf0430-7e96-494d-944c-7bbbe1f81354",
    lyrics: [
"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 1)",
"The Constitution builds our government, step by step, you know it’s true!",
"It gives us leaders like the president, Congress, and the courts we use.",
"Each state has its own set of laws to guide its people every day,",
"but the U.S. Constitution is the highest, it leads the way!",
"In 1787, the framers made their plan, they made their plan.",
"George Washington, Ben Franklin, and others shaped this land.",
"They added amendments to protect our rights, so we’d be free.",
"And the government must follow them—it’s the law for you and me!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 2)",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"Added in 1791 to help our freedoms grow!",
"Added in 1791 to help our freedoms grow!",
"Thousands of changes were proposed, but only 27 were passed.",
"Thousands of changes were proposed, but only 27 were passed.",
"The Constitution stands the test of time, its strength will always last!",
"The Constitution stands the test of time, its strength will always last!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Bill of Rights-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.1 Analyze the structure and function of the United States government in terms of cooperation and compromise.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Compromise-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.1 Analyze the structure and function of the United States government in terms of cooperation and compromise.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Lobbying-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.1 Analyze the structure and function of the United States government in terms of cooperation and compromise.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Protest-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.1 Analyze the structure and function of the United States government in terms of cooperation and compromise.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Boycotts-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.1 Analyze the structure and function of the United States government in terms of cooperation and compromise.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Civil Rights Act-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.2 Understand the ways in which the federal government has protected individual rights of citizens.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----13th Amendment-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.2 Understand the ways in which the federal government has protected individual rights of citizens.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----14th Amendment-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.2 Understand the ways in which the federal government has protected individual rights of citizens.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Latino Civil Rights-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.2 Understand the ways in which the federal government has protected individual rights of citizens.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Internment Camps-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.2 Understand the ways in which the federal government has protected individual rights of citizens.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Pearl Harbor-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.2 Understand the ways in which the federal government has protected individual rights of citizens.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----9/11-----",
    subtitle1: "Topic: 1",
    description: "5.C&G.2 Understand the ways in which the federal government has protected individual rights of citizens.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Industrial Revolution-----",
    subtitle1: "Topic: 1",
    description: "5.E.1 Understand how economic decisions have impacted the United States in terms of consequence, growth, and trade.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Gold Rush-----",
    subtitle1: "Topic: 1",
    description: "5.E.1 Understand how economic decisions have impacted the United States in terms of consequence, growth, and trade.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Louisiana Purchase-----",
    subtitle1: "Topic: 1",
    description: "5.E.1 Understand how economic decisions have impacted the United States in terms of consequence, growth, and trade.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Homesteaders-----",
    subtitle1: "Topic: 1",
    description: "5.E.1 Understand how economic decisions have impacted the United States in terms of consequence, growth, and trade.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Importance of Trade-----",
    subtitle1: "Topic: 1",
    description: "5.E.1 Understand how economic decisions have impacted the United States in terms of consequence, growth, and trade.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Economic Systems-----",
    subtitle1: "Topic: 1",
    description: "5.E.1 Understand how economic decisions have impacted the United States in terms of consequence, growth, and trade.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Subsidy Programs-----",
    subtitle1: "Topic: 1",
    description: "5.E.1 Understand how economic decisions have impacted the United States in terms of consequence, growth, and trade.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Interest Rates-----",
    subtitle1: "Topic: 1",
    description: "5.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Credits & Debts-----",
    subtitle1: "Topic: 1",
    description: "5.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Savings-----",
    subtitle1: "Topic: 1",
    description: "5.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Investments-----",
    subtitle1: "Topic: 1",
    description: "5.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Bankruptcy-----",
    subtitle1: "Topic: 1",
    description: "5.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Economic Systems-----",
    subtitle1: "Topic: 1",
    description: "5.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Social Security-----",
    subtitle1: "Topic: 1",
    description: "5.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Trail of Tears-----",
    subtitle1: "Topic: 1",
    description: "5.G.1 Understand the ways in which geographic factors and features have influenced development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----American Indian Wars-----",
    subtitle1: "Topic: 1",
    description: "5.G.1 Understand the ways in which geographic factors and features have influenced development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Louisiana Purchase-----",
    subtitle1: "Topic: 1",
    description: "5.G.1 Understand the ways in which geographic factors and features have influenced development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Gold Rush-----",
    subtitle1: "Topic: 1",
    description: "5.G.1 Understand the ways in which geographic factors and features have influenced development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Homesteaders-----",
    subtitle1: "Topic: 1",
    description: "5.G.1 Understand the ways in which geographic factors and features have influenced development of the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Revolutionary War-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----War of 1812-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Civil War Causes-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----World War I-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----World War II-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Pearl Harbor-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----9/11-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Harriet Tubman-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Graceanna Lewis-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Ellen Craft-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Nat Turner-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Gabriel Prosser-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Underground Railroad-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Slave Revolts-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Resistance and Reform-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-----Reform and Compromise-----",
    subtitle1: "Topic: 1",
    description: "5.H.1 Understand the role of various people, events, and ideas in shaping the United States.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },


];
export default topics;